import { render } from "./ArchivedUser.vue?vue&type=template&id=3b943894"
import script from "./ArchivedUser.vue?vue&type=script&lang=js"
export * from "./ArchivedUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__